import { BASE_URL } from "config";
import * as base from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/salon/`,
    detail: (id) => `${BASE_URL}/api/v1/salon/${id}/`,
};

export const salonListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const salonDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const salonUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const salonDelete = (token, data) => base.Delete(endpoints.detail, token, data);
